module.exports = __webpack_public_path__ + "static/media/3playerRoomsPlayed_1000000.9000d83e.png";